import { render, staticRenderFns } from "./iamcollect.vue?vue&type=template&id=74e588fc&scoped=true&"
import script from "./iamcollect.vue?vue&type=script&lang=js&"
export * from "./iamcollect.vue?vue&type=script&lang=js&"
import style0 from "./iamcollect.vue?vue&type=style&index=0&id=74e588fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e588fc",
  null
  
)

export default component.exports